import { createSlice } from "@reduxjs/toolkit";
import {
  loginUser,
  logoutUser,
  getUser,
  updateUsersTable,
  clearUserState,
  GoogleloginUser,
  updateUserInfo,
  updateUserPfpInfo,
  removeUserPfpInfo,
  acceptTC,
  submitFeedback,
  forceCloseFeedbackPrompt,
} from "./user.action";

// initial state
const initialState = {
  GoogleToken: null,
  refresh: null,
  rememberMe: false,
  currentCompany: null,
  // currentUser: null,
  statusCode: null,
  token: null,
  apikey: null,
};

// ==============================|| SLICE - USER ||============================== //

const user = createSlice({
  name: "user",
  initialState,
  extraReducers: {
    [loginUser.fulfilled]: (state, { payload }) => {
      state.currentUser = payload[0];
      state.statusCode = payload[1];
      state.token = payload[2];
      state.apikey = payload[3];
      state.rememberMe = payload[4];
      state.refresh = payload[5];
      localStorage.token = state.token;
      localStorage.apiKey = state.apikey;
      localStorage.rememberMe = state.rememberMe;
      if (state.rememberMe === true) {
        localStorage.refresh = state.refresh;
      }
    },
    [loginUser.rejected]: (state, { payload }) => {
      state.statusCode = payload[1];
      state.token = null;
      state.apikey = null;
      localStorage.token = null;
      localStorage.apiKey = null;
    },
    [logoutUser.fulfilled]: (state, { payload }) => {
      state.currentUser = null;
      state.currentCompany = null;
      state.statusCode = payload[1];
      state.token = null;
      state.apikey = null;
      state.rememberMe = null;
      state.GoogleToken = null;
      state.refresh = null;
      localStorage.GoogleToken = null;
      localStorage.refresh = null;
      localStorage.rememberMe = null;
      localStorage.token = null;
      localStorage.apiKey = null;
      sessionStorage.clear();
    },
    [getUser.fulfilled]: (state, { payload }) => {
      state.currentUser = payload[0];
      state.statusCode = payload[1];
      state.token = payload[2];
      state.apikey = payload[3];
    },
    [getUser.rejected]: (state, action) => {
      state.currentUser = null;
      state.statusCode = 404;
      state.token = null;
      state.apikey = null;
      localStorage.token = null;
      localStorage.apiKey = null;
      action.error.message = action.payload;
    },
    [updateUsersTable.fulfilled]: (state, { payload }) => {
      state.currentUser.CompanyUEN = payload[0];
    },
    [updateUserInfo.fulfilled]: (state, action) => {
      const userData = JSON.parse(action.payload.config.data);
      // Replace "null" with null in the userData object
      for (const key in userData) {
        if (userData[key] === "null") {
          userData[key] = null;
        }
      }
      state.currentUser = userData;
    },
    [updateUserPfpInfo]: (state, action) => {
      state.currentUser.ProfilePicture = action.payload;
    },
    [removeUserPfpInfo]: (state) => {
      state.currentUser.ProfilePicture = null;
    },
    // revert to initial state
    [clearUserState]: (state) => {
      state.currentUser = null;
      state.statusCode = 200;
      localStorage.token = null;
      localStorage.apiKey = null;
    },
    [GoogleloginUser.fulfilled]: (state, { payload }) => {
      // console.log(`Entered slice! - ${JSON.stringify(payload)}`);
      state.currentUser = payload[0];
      state.statusCode = payload[1];
      state.GoogleToken = payload[2];
      state.apikey = payload[3];
      localStorage.GoogleToken = state.GoogleToken;
      localStorage.apiKey = state.apikey;
    },
    [GoogleloginUser.rejected]: (state, { payload }) => {
      state.statusCode = payload[1];
      state.GoogleToken = null;
      state.apikey = null;
      localStorage.GoogleToken = null;
      localStorage.apiKey = null;
    },
    [acceptTC.fulfilled]: (state, {payload}) => {
      state.currentUser.PromptTC = false;
    },
    [submitFeedback.fulfilled]: (state, {payload}) => {
      state.currentUser.PromptFeedback = false;
    },
    [forceCloseFeedbackPrompt.fulfilled]: (state, {}) => {
      state.currentUser.PromptFeedback = false;
    }
  },
});

export default user.reducer;
